import React from 'react';
import MediaQuery from 'react-responsive';
import { Tabs, Tab } from 'material-ui/Tabs';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import SlackSourceManager from '../../containers/slack_source_manager';
import WebexSourceManager from '../../containers/webex_source_manager';
// import FacebookSourceManager from '../../containers/facebook_source_manager';
import NoDeviceMessage from '../../containers/no_device_message';
import DeviceManager from '../../containers/device_manager';
import InviteManager from '../../containers/invite_manager';
import COLORS from '../../theme/colors';
import './dashboard.scss';

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 'sources',
    };
  }

  handleTabChanged(tab) {
    this.setState({ currentTab: tab });
  }

  render() {
    return (
      <div className="dashboard">
        <div className="content">
          <MediaQuery minDeviceWidth={480}>
            <Tabs
              className="dashboard-tabs"
              value={this.state.currentTab}
              onChange={tab => this.handleTabChanged(tab)}
            >
              <Tab label="Sources" value="sources">
                <div className="tabs-content">
                  <SlackSourceManager />
                  <WebexSourceManager />
                  {/* <FacebookSourceManager /> */}
                  <NoDeviceMessage
                    navigate={() => {
                      this.handleTabChanged('devices');
                    }}
                  />
                </div>
              </Tab>
              <Tab label="Devices" value="devices">
                <div className="tabs-content">
                  <DeviceManager />
                </div>
              </Tab>
              <Tab label="Invites" value="invites">
                <div className="tabs-content">
                  <InviteManager />
                </div>
              </Tab>
            </Tabs>
          </MediaQuery>

          <MediaQuery maxDeviceWidth={479}>
            <Card initiallyExpanded>
              <CardHeader
                title="Sources"
                titleColor={COLORS.white}
                style={{ backgroundColor: COLORS.turquoise }}
                actAsExpander
                showExpandableButton
              />
              <CardText expandable>
                <SlackSourceManager />
                <WebexSourceManager />
                {/* <FacebookSourceManager /> */}
                <NoDeviceMessage
                  navigate={() => {
                    this.handleTabChanged('devices');
                  }}
                />
              </CardText>
            </Card>

            <Card>
              <CardHeader
                title="Devices"
                titleColor={COLORS.white}
                style={{ backgroundColor: COLORS.turquoise }}
                actAsExpander
                showExpandableButton
              />
              <CardText expandable>
                <DeviceManager />
              </CardText>
            </Card>

            <Card>
              <CardHeader
                title="Invites"
                titleColor={COLORS.white}
                style={{ backgroundColor: COLORS.turquoise }}
                actAsExpander
                showExpandableButton
              />
              <CardText expandable>
                <InviteManager />
              </CardText>
            </Card>
          </MediaQuery>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.jsx